import * as React from 'react'

import { Box, Icon, Popover, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Description from './Description'

interface HistoryPopoverProps {
  changes: string[]
}

const HistoryPopover = ({ changes }: HistoryPopoverProps) => {
  const [open, toggle] = useToggle()

  return (
    <Popover.ItemList
      attachment="top center"
      targetAttachment="bottom center"
      toggle={toggle}
      open={open}
    >
      <Box width="s32" justifyContent="center" alignItems="center">
        <Icon.Medium icon="info-circle-line" color="grey800" />
      </Box>
      <Description changes={changes} />
    </Popover.ItemList>
  )
}

export default observer(HistoryPopover)
